<template>
    <div class="col-6 mt-3 col-campaign" @click="clickCampaign()">
        <div class="wrapper-campaign">
            <div class="wrapper-img">
                <img :src="campaign.fullImageUrl" />
            </div>
            <div class="card-body">
                <div class="campaign-name ellipsis-2">{{ campaign.name }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
// import Locale from "@/helper/locale/locale.js";
export default {
    name: "CampaignItem",
    props: {
        lbl: Object,
        index: Number,
        campaign: Object,
        isSearch: Boolean
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign
        };
    },
    created: function() {
    },
    mounted: function() {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function() {
            //GA
            var label = this.campaign.id+"|"+this.campaign.name;
            var gtm = {
                 "event_label": this.campaign.name,
                 "privilege_category_name": this.campaign.categoryName,
                 "privilege_id": this.campaign.id.toString(),
                 "timestamp": moment().format("YYYYMMDD HH:mm:ss")
            };
            if (this.isSearch) {
                Vue.ga.event(this, "privilege", "click_privilege_card_result", label, null, gtm);
            } else {
                Vue.ga.event(this, "privilege", "click_card_privilege_detail", label, null, gtm);
            }

            this.toggleBodyClass("addClass","keep-home");
            this.$router.push({ name: 'detail', params: { campaignId: this.campaign.id }})
        },
        //method
        isSoldOut: function() {
            return this.campaign.qty < 1 ? true : false;
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
            el.classList.add(className);
            } else {
            el.classList.remove(className);
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.col-campaign:nth-child(odd) {
    padding-right: 7.5px;
}

.col-campaign:nth-child(even) {
    padding-left: 7.5px;
}

.wrapper-campaign {
    overflow: hidden;
    border-radius: 15px;
    background-color: white;

    .wrapper-img {
        position: relative;
        width: 100%; /* desired width */

        img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .wrapper-img:before {
        content: "";
        display: block;
        padding-top: 66.66%; /* initial ratio of 1:1*/
    }

    .card-body {
        padding: 10px;
        // line-height: 1.2;
        // font-size: 0.9em;
        font-size: 17px;
        line-height: 1;
        height: 54px;
    }
}
</style>
